import { useState, useEffect } from 'react'

export type Language = 'en' | 'fr' | 'yo' | 'ig'

export const languages = [
  { code: 'en' as Language, label: 'English', flag: '🇺🇸' },
  { code: 'fr' as Language, label: 'Français', flag: '🇫🇷' },
  { code: 'yo' as Language, label: 'Yorùbá', flag: '🇳🇬' },
  { code: 'ig' as Language, label: 'Igbo', flag: '🇳🇬' },
]

export function useLanguage() {
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem('language')
    return (saved as Language) || 'en'
  })

  useEffect(() => {
    localStorage.setItem('language', language)
    document.documentElement.lang = language
  }, [language])

  const t = (key: string): string => {
    return key
  }

  return { language, setLanguage, t }
}
